import classnames from 'classnames'
import Portal from '../Portal'
import PopoverArrow from './PopoverArrow'
import {usePopoverContext} from './PopoverContext'

const PopoverContent = ({children, className}) => {
    const {
        isOpen,
        setIsOpen,
        refs,
        floatingStyles,
        isPositioned,
        getFloatingProps,
        showArrow,
        backdrop,
        size,
        radius,
        shadow,
    } = usePopoverContext()

    const backdropClass = classnames('popover-new-backdrop', {
        [`popover-new-backdrop--${backdrop}`]: backdrop !== 'transparent',
    })

    const panelClass = classnames(
        'popover-new',
        `popover-new--size-${size}`,
        `popover-new--radius-${radius}`,
        `popover-new--shadow-${shadow}`,
        className
    )

    return (
        <Portal containerId="popover-new-root">
            {isOpen && backdrop !== 'transparent' && <div className={backdropClass} />}
            <div
                ref={refs.setFloating}
                style={{...floatingStyles, visibility: (isOpen && isPositioned) ? 'visible' : 'hidden'}}
                className={panelClass}
                {...getFloatingProps()}
            >
                {isOpen && (typeof children === 'function' ? children(() => setIsOpen(false)) : children)}
                {showArrow && <PopoverArrow />}
            </div>
        </Portal>
    )
}

export default PopoverContent
